// extracted by mini-css-extract-plugin
export default {"backgroundImage":"DesktopComponent_backgroundImage__C6T6X"};